import { Props_SnippetSingleLink } from './SingleLink.props'
import SnippetLink from '../Shared/Link/Link'

const SnippetSingleLink = (props: Props_SnippetSingleLink) => {
    const { repeatable_link, linkProps } = props

    const linkAlignmentClass = `snippet-single-link--${linkProps.alignment.value}`

    return (
        <section className={`snippet-single-link ${linkAlignmentClass}`}>
            <div className="snippet-single-link__container">
                    {repeatable_link?.map(({ linkHref, linkTarget, linkText, linkStyle,linkFontSize, linkWidth, linkAriaLabel }, index) => {
                        const buttonClassNames = [
                            'snippet-single-link__link',
                            linkFontSize?.value && `snippet-single-link__link--${linkFontSize.value}`,
                            linkWidth?.value && `snippet-single-link__link--${linkWidth.value}`
                        ].filter(Boolean).join(' ')
                        return (
                            <SnippetLink
                                key={`link-${linkHref?.value}-${index}`}
                                linkStyles={linkStyle?.value}
                                className={buttonClassNames}
                                url={linkHref?.value}
                                openInNewTab={linkTarget?.value}
                                aria-label={linkAriaLabel?.value || linkText?.value}
                            >
                                {linkText?.value}
                            </SnippetLink>
                        )
                    })}
            </div>
        </section>
    )
}

export default SnippetSingleLink
